var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAutobiztrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360.785,
    height: 73.848,
    viewBox: "0 0 402.785 73.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "translate(-143.999 -124.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11486",
    "data-name": "Path 11486",
    d: "M456.118,226.665c2.852-3.071,6.69-4,11.186-4,7.9,0,11.626,2.852,11.626,10.749v17.822h-7.293l-.054-3.565a9.47,9.47,0,0,1-8.117,4.276,8.879,8.879,0,0,1-6.142-2.193,8.312,8.312,0,0,1-2.467-6.471c0-3.4,1.207-5.7,3.454-7.239,2.414-1.646,6.033-2.249,9.762-2.249h2.962v-.713c0-3.071-1.044-4-4.115-4a8.8,8.8,0,0,0-6.58,2.469Zm11.571,12.611c-3.017,0-4.772.385-4.772,3.621,0,1.753.494,2.8,1.975,2.8,2.3,0,5.921-2.523,6.306-6.416Z",
    transform: "translate(-216.738 -73.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11487",
    "data-name": "Path 11487",
    d: "M486.44,250.961v-4.278a8.716,8.716,0,0,1-8.172,4.99c-5.318,0-8.006-3.509-8.006-9.925V222.994h8.556v17.438c0,2.029.437,3.4,2.138,3.4,2.412,0,4.881-2.96,4.881-9.377V222.994h8.555v27.967Z",
    transform: "translate(-204.181 -72.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11488",
    "data-name": "Path 11488",
    d: "M505.249,254.147a24.883,24.883,0,0,1-5.866.713c-7.789,0-9.927-3.839-9.927-10.693v-9.651H485.4v-7.458h4.059v-7.678l8.609-.768v8.446h6.91v7.458h-6.91v8.992c0,2.906.054,3.839,3.127,3.839a16,16,0,0,0,3.563-.385Z",
    transform: "translate(-191.844 -76.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11489",
    "data-name": "Path 11489",
    d: "M519.956,248.887c-2.3,2.193-5.209,3.291-9.431,3.291-4.113,0-6.965-1.042-9.1-3.015-2.852-2.579-3.73-6.033-3.73-11.408,0-5.649.987-9.1,3.784-11.845,2.3-2.247,5.264-3.4,9.488-3.4,4.057,0,7.019,1.042,9.157,3.017,2.8,2.577,3.674,6.142,3.674,11.517C523.795,242.581,522.864,246.09,519.956,248.887ZM513.7,230.736a3.331,3.331,0,0,0-2.741-.987,3.825,3.825,0,0,0-3.071,1.1c-.987,1.151-1.37,3.728-1.37,6.743,0,3.182.437,5.54,1.26,6.418a3.8,3.8,0,0,0,2.852.986,3.65,3.65,0,0,0,2.962-1.151c.987-1.153,1.425-3.51,1.425-6.747C515.021,234.081,514.638,231.832,513.7,230.736Z",
    transform: "translate(-181.823 -73.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11490",
    "data-name": "Path 11490",
    d: "M522.644,215.29v16.833a8.943,8.943,0,0,1,7.569-3.563c8.061,0,9.6,7.073,9.6,14.2,0,7.567-1.7,15.025-10.749,15.025a8.848,8.848,0,0,1-7.565-3.456l-.165,2.908h-7.295V215.29Zm5.155,20.727a4.4,4.4,0,0,0-3.617,2.031,10.292,10.292,0,0,0-1.864,6.36,6.644,6.644,0,0,0,1.479,4.77,4.365,4.365,0,0,0,3.454,1.537c3.18,0,3.73-2.743,3.73-7.4S530.431,236.017,527.8,236.017Z",
    transform: "translate(-168.501 -79.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11491",
    "data-name": "Path 11491",
    d: "M534.82,215.078a5.128,5.128,0,1,1-5.046,5.155A5.022,5.022,0,0,1,534.82,215.078Zm4.331,14.368v27.967h-8.609V229.446Z",
    transform: "translate(-155.672 -79.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11492",
    "data-name": "Path 11492",
    d: "M558.124,230.194,547.649,243.41H558.4v7.4h-21.22v-7.075l10.419-13.161h-9.87v-7.4h20.4Z",
    transform: "translate(-149.639 -72.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11493",
    "data-name": "Path 11493",
    d: "M579.493,217.555v7.9h-9.705v29.942H560.9V225.453h-9.649v-7.9Z",
    transform: "translate(-138.165 -77.187)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11494",
    "data-name": "Path 11494",
    d: "M576.317,223.265l-.054,4.387c1.425-3.127,3.563-4.992,6.58-4.992a7.925,7.925,0,0,1,1.646.165l-.659,8.335a12.578,12.578,0,0,0-1.427-.109c-4.551,0-5.594,5.429-5.594,10.8v9.379H568.2V223.265Z",
    transform: "translate(-124.352 -73.025)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11495",
    "data-name": "Path 11495",
    d: "M579.551,226.665c2.853-3.071,6.691-4,11.187-4,7.9,0,11.628,2.852,11.628,10.749v17.822h-7.295l-.054-3.565a9.467,9.467,0,0,1-8.115,4.276,8.879,8.879,0,0,1-6.142-2.193,8.313,8.313,0,0,1-2.469-6.471c0-3.4,1.207-5.7,3.454-7.239,2.414-1.646,6.035-2.249,9.762-2.249h2.962v-.713c0-3.071-1.042-4-4.113-4a8.8,8.8,0,0,0-6.58,2.469Zm11.571,12.611c-3.017,0-4.772.385-4.772,3.621,0,1.753.5,2.8,1.975,2.8,2.3,0,5.923-2.523,6.308-6.416Z",
    transform: "translate(-116.127 -73.025)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11496",
    "data-name": "Path 11496",
    d: "M619.757,215.29v41.951H611.7l-.111-3.676a9.521,9.521,0,0,1-8.172,4.387,8.193,8.193,0,0,1-6.3-2.686c-2.194-2.412-3.293-6.088-3.293-11.791,0-5.373.987-9.431,3.676-12.009a10.7,10.7,0,0,1,7.787-2.852,8.138,8.138,0,0,1,5.868,1.975v-15.3Zm-10.584,33.231a11.33,11.33,0,0,0,2.3-7.13,5.936,5.936,0,0,0-1.425-4.442,4.491,4.491,0,0,0-3.234-1.151c-3.347,0-3.95,2.358-3.95,7.567,0,5.375.657,7.239,2.8,7.239A4.5,4.5,0,0,0,609.173,248.521Z",
    transform: "translate(-103.471 -79.033)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11497",
    "data-name": "Path 11497",
    d: "M635.255,247.279c-3.124,3.18-6.963,4.659-11.9,4.659-3.9,0-6.91-.987-9.05-2.85-2.467-2.194-3.785-5.7-3.785-11.243,0-4.607.933-8.885,3.676-11.736,1.975-2.027,4.992-3.509,9.6-3.509,9.048,0,11.845,5.757,11.845,13.49a24.106,24.106,0,0,1-.22,3.291l-16.5.165c.055,3.617.712,5.757,4.714,5.757a10.689,10.689,0,0,0,7.4-2.962ZM627.468,233.9c-.054-3.236-.6-5.046-4-5.046-3.454,0-4.331,1.975-4.442,5.046Z",
    transform: "translate(-89.855 -73.074)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(238.118 135.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11503",
    "data-name": "Path 11503",
    d: "M579.493,217.555v7.9h-9.705v29.942H560.9V225.453h-9.649v-7.9Z",
    transform: "translate(-376.282 -213.059)",
    fill: "#007951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11504",
    "data-name": "Path 11504",
    d: "M576.317,223.265l-.054,4.387c1.425-3.127,3.563-4.992,6.58-4.992a7.925,7.925,0,0,1,1.646.165l-.659,8.335a12.578,12.578,0,0,0-1.427-.109c-4.551,0-5.594,5.429-5.594,10.8v9.379H568.2V223.265Z",
    transform: "translate(-362.469 -208.897)",
    fill: "#007951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11505",
    "data-name": "Path 11505",
    d: "M579.551,226.665c2.853-3.071,6.691-4,11.187-4,7.9,0,11.628,2.852,11.628,10.749v17.822h-7.295l-.054-3.565a9.467,9.467,0,0,1-8.115,4.276,8.879,8.879,0,0,1-6.142-2.193,8.313,8.313,0,0,1-2.469-6.471c0-3.4,1.207-5.7,3.454-7.239,2.414-1.646,6.035-2.249,9.762-2.249h2.962v-.713c0-3.071-1.042-4-4.113-4a8.8,8.8,0,0,0-6.58,2.469Zm11.571,12.611c-3.017,0-4.772.385-4.772,3.621,0,1.753.5,2.8,1.975,2.8,2.3,0,5.923-2.523,6.308-6.416Z",
    transform: "translate(-354.245 -208.897)",
    fill: "#007951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11506",
    "data-name": "Path 11506",
    d: "M619.757,215.29v41.951H611.7l-.111-3.676a9.521,9.521,0,0,1-8.172,4.387,8.193,8.193,0,0,1-6.3-2.686c-2.194-2.412-3.293-6.088-3.293-11.791,0-5.373.987-9.431,3.676-12.009a10.7,10.7,0,0,1,7.787-2.852,8.138,8.138,0,0,1,5.868,1.975v-15.3Zm-10.584,33.231a11.33,11.33,0,0,0,2.3-7.13,5.936,5.936,0,0,0-1.425-4.442,4.491,4.491,0,0,0-3.234-1.151c-3.347,0-3.95,2.358-3.95,7.567,0,5.375.657,7.239,2.8,7.239A4.5,4.5,0,0,0,609.173,248.521Z",
    transform: "translate(-341.589 -214.905)",
    fill: "#007951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507",
    "data-name": "Path 11507",
    d: "M635.255,247.279c-3.124,3.18-6.963,4.659-11.9,4.659-3.9,0-6.91-.987-9.05-2.85-2.467-2.194-3.785-5.7-3.785-11.243,0-4.607.933-8.885,3.676-11.736,1.975-2.027,4.992-3.509,9.6-3.509,9.048,0,11.845,5.757,11.845,13.49a24.106,24.106,0,0,1-.22,3.291l-16.5.165c.055,3.617.712,5.757,4.714,5.757a10.689,10.689,0,0,0,7.4-2.962ZM627.468,233.9c-.054-3.236-.6-5.046-4-5.046-3.454,0-4.331,1.975-4.442,5.046Z",
    transform: "translate(-327.973 -208.946)",
    fill: "#007951"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 73.848,
    height: 73.848,
    transform: "translate(217.847 124.837) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11498",
    "data-name": "Path 11498",
    d: "M474.278,211.571v68.7h-68.7v-68.7h68.7M476.85,209H403v73.847H476.85V209Z",
    transform: "translate(-259.004 -84.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 62.344,
    height: 62.344,
    transform: "translate(212.095 130.589) rotate(90)",
    fill: "#00693b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11499",
    "data-name": "Path 11499",
    d: "M442.267,256.555l-22.894-22.9,7.3-7.3,22.9,22.9Zm-17.436-22.9L442.267,251.1l1.848-1.846-17.438-17.438Z",
    transform: "translate(-245.661 -70.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11500",
    "data-name": "Path 11500",
    d: "M423.247,246.566l-10.994-10.992,16.34-16.338,10.992,10.992Zm-5.536-10.992,5.536,5.534,10.88-10.88-5.534-5.534Z",
    transform: "translate(-251.464 -75.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11501",
    "data-name": "Path 11501",
    d: "M432.083,236.105l-12.738-12.737,7.09-7.092,12.738,12.738Zm-7.823-12.737,7.823,7.821,2.174-2.174-7.823-7.823Z",
    transform: "translate(-245.684 -78.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11502",
    "data-name": "Path 11502",
    d: "M422.033,246.154,409.3,233.416l7.09-7.088,12.738,12.737Zm-7.823-12.738,7.823,7.823,2.174-2.174-7.823-7.821Z",
    transform: "translate(-253.875 -70.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 6.47,
    height: 3.858,
    transform: "translate(191.201 178.405) rotate(-45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAutobiztrade);
export default __webpack_public_path__ + "static/media/logo_autobiztrade.1b78794d323691db5a649b84645dd2d5.svg";
export { ForwardRef as ReactComponent };